import { Command } from '@nextforce/api'
import { makeStyles } from '@rneui/themed'
import { groupBy } from 'lodash'
import React from 'react'
import { View } from 'react-native'
import { CommandButton } from './command_button'

interface Props {
  commands?: Command[]
  onButtonPress(command: Command): Promise<void>
  disabled?: boolean
}

export function CommandButtons({ commands, onButtonPress, disabled }: Props) {
  const styles = useStyles()

  if (!commands) {
    return null
  }

  const commandsByGroupId = groupBy(commands, command => command.groupId)

  return (
    <View>
      {Object.keys(commandsByGroupId).map(group => {
        return (
          <View style={styles.buttonRow} key={group}>
            {commandsByGroupId[group].map((command, index) => {
              return (
                <CommandButton
                  containerStyle={styles.button}
                  command={command}
                  onPress={onButtonPress}
                  key={index}
                  disabled={disabled}
                />
              )
            })}
          </View>
        )
      })}
    </View>
  )
}

const useStyles = makeStyles(theme => ({
  buttonRow: {
    flexDirection: 'row',
    margin: 5,
    justifyContent: 'space-between',
  },
  button: {
    flex: 1,
    marginHorizontal: 5,
  },
}))
